import type { FaireProductEntity } from "../../entity_types/product";

export const p_6w3bd6jyk7: FaireProductEntity = {
  token: "p_6w3bd6jyk7",
  type: "product",
  name: "Hinoki Sesame - elsewhere Collection Incense Cones",
  brandToken: "b_oaph28jf",
  brandName: "dilo",
  imageUrl:
    "https://cdn.faire.com/fastly/7aaffbeae01926a45e47d9d254644b97f47bf82c99234d5327be88f3b335961f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eba2b0da3ac92ee696d8ca4977c3503260f9aae001e49ceefcb0e69a8784f91b.jpeg",
    "https://cdn.faire.com/fastly/38f9e49f76bb396e399f2ac8d8682aa5706680c13440d7c1f7314d5908b23e0b.png",
    "https://cdn.faire.com/fastly/a1b35110881be33e24ed6ccb3fe4b469dee93ff756234304dcfa7ddd1d476c7d.jpeg",
    "https://cdn.faire.com/fastly/b7adf11729fdd04e65892e056aaf6bdf84f8db4864f26badcbf3fa952fbf1f2d.png",
  ],
  priceDollars: 10,
  description:
    " Tin contains 25 Incense Cones - Resin + Fragrance\n\nHinoki Sesame - Coastal Sea Salt Air rises through Centuries-Old Hinoki Cypress Trees\n\nOr choose from 3 other elsewhere Fragrance Profiles\n\nDesert Kush - Juicy Yuzu and Grapefruit on top of a Hempy Kushy Pillow of Smoky Teakwood\n\nPalo Santo - Smokey peppercorn notes toned down by Amber Resin and Palo Santo Wood.\n\nCactus Flower - Bright notes of Mandarin and Bergamot settle into a Mossy Redwood Smoke. \n\nFind the Set of 4 HERE\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:36.954Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
